<template>
  <div class="header-wrapper">
    
    <header class="header">
      <img class="logo" src="../../public/logo.png" alt="Valoria" @click="goToCategory">

      <div class="action-bar2">
        <!-- Notification Icon -->
        <!--div class="action-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
        </div-->

        <!-- User Menu Icon -->
        <div class="user-menu action-icon" @click="toggleAuth">
           <svg v-if="!store.user.token" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
             <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
             <circle cx="12" cy="7" r="4"></circle>
           </svg>
           <div v-else class="user-logged" @click.stop="showUserMenu = !showUserMenu">
              <span class="user-initial">{{ store.user.info?.name?.charAt(0).toUpperCase() }}</span>
              <div v-if="showUserMenu" class="dropdown-menu2">
                 <div class="menu-item">{{ store.user.info?.name }}</div>
                 <div class="menu-item" @click="router.push('/history')">{{ $t('myOrders') || 'My Orders' }}</div>
                 <div class="menu-item lang-item">
                    <LanguageSwitcher />
                 </div>
                 <div class="menu-item logout" @click="store.logout()">{{ $t('logout') || 'Logout' }}</div>
              </div>
           </div>
        </div>

        <!-- Hamburger Menu Icon -->
        <div class="action-icon menu-icon" @click="isMenuSidebarOpen = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </div>
      </div>

      <AuthModal v-if="store.isAuthModalOpen" @close="store.isAuthModalOpen = false" />
    </header>
    <AnnouncementBar v-if="annoucement" :annoucement="annoucement" />

    <MenuSidebar :is-open="isMenuSidebarOpen" @close="isMenuSidebarOpen = false" />
  </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue'
  import { useRouter } from 'vue-router'
  import LanguageSwitcher from './LanguageSwitcher.vue'
  import AuthModal from './auth/AuthModal.vue'
  import AnnouncementBar from './layout/AnnouncementBar.vue'
  import MenuSidebar from './layout/MenuSidebar.vue'
  import store from '../store'

  const router = useRouter()
  const showUserMenu = ref(false)
  const isMenuSidebarOpen = ref(false)

  const annoucement = ref("L’élégance SEVENWEAR • Nouvelle collection disponible • Livraison partout en Algérie • Paiement à la livraison • Qualité premium • Des pièces pensées pour sublimer • Style moderne et raffiné •")

  const goToCategory = () => {
    router.push('/')
  }

  const toggleAuth = () => {
    if (!store.user.token) {
      store.isAuthModalOpen = true
    }
  }

  const closeMenu = (e) => {
     if(!e.target.closest('.user-logged')) {
         showUserMenu.value = false
     }
  }

  onMounted(() => {
     document.addEventListener('click', closeMenu)
  })
  onUnmounted(() => {
     document.removeEventListener('click', closeMenu)
  })
  </script>
  
  <style scoped>
    .header-wrapper {
      position: sticky;
      top: 0;
      z-index: 50;
    }

    .header {
      position: relative;
      height: 60px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #ffffffde;
      backdrop-filter: blur(4px);
      box-shadow: none;
      border-bottom: 1px solid rgba(0,0,0,0.1);
      padding: 0 20px;
      z-index: 200;
    }
  
    .logo {
      width: 100px;
      min-width: 80px;
      cursor: pointer;
    }

    .action-bar2 {
      display: flex;
      gap: 12px;
      align-items: center;
      background-color: rgba(221, 255, 243, 0.4);
      padding: 8px 16px;
      border-radius: 9999px;
    }

    .action-icon {
      color: var(--text-dark, #121212);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: color 0.2s;
    }

    .action-icon:hover {
      color: var(--text-dark, #121212);
    }

    .cart-icon {
       position: relative;
       cursor: pointer;
       display: flex;
       align-items: center;
       justify-content: center;
       color: #1e293b;
    }

    .cart-badge {
       position: absolute;
       top: -8px;
       right: -8px;
       background: #ef4444;
       color: white;
       font-size: 0.7rem;
       font-weight: bold;
       border-radius: 50%;
       width: 18px;
       height: 18px;
       display: flex;
       align-items: center;
       justify-content: center;
    }

    .header-left {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    .user-logged {
        position: relative;
    }

    .user-menu {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .user-initial {
      width: 32px;
      height: 32px;
      background: #3b82f6;
      color: white;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }

    .dropdown-menu2 {
      position: absolute;
      top: 40px;
      right: 0;

      background: #fff;
      opacity: 1;

      border: 1px solid #e2e8f0;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      min-width: 150px;
      overflow: hidden;
    }

    html[dir="rtl"] .dropdown-menu2 {
      right: auto;
      left: 0;
    }

    .menu-item {
      padding: 10px 15px;
      font-size: 0.9rem;
      color: #1e293b;
      background: white;
      white-space: nowrap;
      cursor: pointer;
      text-align: left;
    }
    html[dir="rtl"] .menu-item {
       text-align: right;
    }

    .menu-item:hover {
       background: #f8fafc;
    }

    .menu-item.logout {
      border-top: 1px solid #f1f5f9;
      color: #ef4444;
    }

    .menu-item.logout:hover {
      background: #fef2f2;
    }
  </style>
